import Vue from 'vue'
import Router from 'vue-router'
import stock from "../components/Stock";
import examine from "../components/Examine";
import examineDetail from "../components/ExamineDetail";
import appointment from "../components/Appointment";
import checkAppointment from "../components/CheckAppointment";
import qrcode from "../components/QRcode";
import qrcodeCheck from "../components/QRcodeCheck";
import schmearpost from "../components/Schmearpost"
import schmearpostClose from "../components/SchmearpostClose"
import schmearpostCreate from "../components/SchmearpostCreate"
import clockIn from "../components/ClockIn"
import pickData from "../components/PickData";
import luckDraw from "../components/LuckDraw";
import extension from "../components/Extension";
import ticketInfo from "../components/AftersaleService";
import aftersaleServicePdf from "../components/AftersaleServicePdf";
import evaluate from "../components/Evaluate";
import vote from "../components/Vote";
import voteResult from "../components/VoteResult";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/ui/examine',
      name: 'examine',
      component: examine,
    },
    {
      path: '/ui/stock',
      name: 'stock',
      component: stock,
    },
    {
      path: '/ui/examineDetail',
      name: 'examineDetail',
      component: examineDetail,
    },
    {
      path: '/ui/appointment',
      name: 'appointment',
      component: appointment,
    },
    {
      path: '/ui/checkAppointment',
      name: 'checkAppointment',
      component: checkAppointment,
    },
    {
      path: '/ui/qrcode',
      name: 'qrcode',
      component: qrcode,
    },
    {
      path: '/ui/qrcodeCheck',
      name: 'qrcodeCheck',
      component: qrcodeCheck,
    },
    {
      path: '/ui/schmearpost',
      name: 'schmearpost',
      component: schmearpost,
    },
    {
      path: '/ui/schmearpostClose',
      name: 'schmearpostClose',
      component: schmearpostClose,
    },
    {
      path: '/ui/schmearpostCreate',
      name: 'schmearpostCreate',
      component: schmearpostCreate,
    },
    {
      path: '/ui/clockIn',
      name: 'clockIn',
      component: clockIn,
    },
    {
      path: '/ui/pickdata',
      name: 'pickdata',
      component: pickData,
    },
    {
      path: '/ui/luckDraw',
      name: 'luckDraw',
      component: luckDraw,
    },
    {
      path: '/ui/extension',
      name: 'extension',
      component: extension,
    },
    {
      path: '/ui/ticketInfo',
      name: 'ticketInfo',
      component: ticketInfo,
    },
    {
      path: '/ui/aftersaleServicePdf',
      name: 'aftersaleServicePdf',
      component: aftersaleServicePdf,
    },
    {
      path: '/ui/evaluate',
      name: 'evaluate',
      component: evaluate,
    },
    {
      path: '/ui/vote',
      name: 'vote',
      component: vote,
    },
    {
      path: '/ui/voteResult',
      name: 'voteResult',
      component: voteResult,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js